import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { Modulos } from 'src/app/core/modulos';
import { AcessoModuloResolver } from 'src/app/guards/acesso-modulo.resolve';
import { AuthGuard } from './../../guards/auth.guard';
import { CadastrarTipoReuniaoComponent } from './cadastrar-tipo-reuniao/cadastrar-tipo-reuniao.component';
import { TipoReuniaoComponent } from './tipo-reuniao.component';

const routes: Routes = [
  {path: 'tiposreunioes/cadastrar', component: CadastrarTipoReuniaoComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.TIPO_REUNIAO}},
  {path: 'tiposreunioes', component: TipoReuniaoComponent, canActivate: [AuthGuard],resolve: {perfilAcesso:AcessoModuloResolver}, data:{modulo:Modulos.TIPO_REUNIAO}}
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TipoReuniaoRoutingModule { }
